import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: '"degular", sans-serif',
    h1: {
      color: "#272726",
      fontFamily: '"ivymode", serif',
    },
    h2: {
      color: "#272726",
      fontFamily: '"ivymode", monospace',
    },
    h3: {
      color: "#272726",
      fontFamily: '"ivymode", monospace',
    },
    body1: {
      fontFamily: '"degular", serif',
      color: "#272726",
      fontWeight: 500,
      fontSize: "14px",
      fontStyle: "normal",
      lineHeight: "28px", // 150%
    },
    body2: {
      fontFamily: '"degular", serif',
      fontWeight: 400,
      fontSize: "12px",
      fontStyle: "normal",
      color: "#272726",
      lineHeight: "24px", // 150%
    },
    caption: {
      color: "#272726",
      fontFamily: "degular",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "10px",
      lineHeight: "20px", // 150%
    },
  },
  palette: {
    primary: {
      main: "#282828", // Blu principale
      light: "#3399FF", // Blu chiaro
      dark: "#0056B3", // Blu scuro
      contrastText: "#fff",
    },
    secondary: {
      main: "#C0C0C0", // Argento principale
      light: "#ece9e0", // Argento chiaro
      dark: "#282828", // Argento scuro
      contrastText: "#fff",
    },
    error: {
      main: "#d32f2f",
      light: "#ef5350",
      dark: "#c62828",
      contrastText: "#fff",
    },
    warning: {
      main: "#ed6c02",
      light: "#ff9800",
      dark: "#e65100",
      contrastText: "#fff",
    },
    info: {
      main: "#0288d1",
      light: "#03a9f4",
      dark: "#01579b",
      contrastText: "#fff",
    },
    success: {
      main: "#2e7d32",
      light: "#4caf50",
      dark: "#1b5e20",
      contrastText: "#fff",
    },
  },
  breakpoints: {
    values: {
      xs: 375,
      sm: 600,
      md: 900,
      lg: 1380,
      xl: 1800,
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "transparent",
          boxShadow: "none",
          padding: 0,
          maxWidth: "none",
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: 2,
        },
      },
    },
  },
});

export default theme;
